import { Col, Row } from "antd";
import { Contact } from "../../../../../features/Vendor/vendor.type";
import { formatBDMobile } from "../../../../../utils/string";

const ContactDetails = ({ data }: { data?: Contact[] }) => {
  const formattedData = data?.map((item) => {
    if (!item?.name) return [];

    const details = [];

    if (item?.name) {
      details.push({ label: "Contact Person", value: item.name });
    }

    if (item?.contact_number) {
      details.push({
        label: "Contact Number",
        value: formatBDMobile(item.contact_number),
      });
    }

    if (item?.email) {
      details.push({ label: "Email Address", value: item.email });
    }

    if (item?.designation) {
      details.push({ label: "Designation", value: item.designation });
    }

    return details;
  });

  return (
    <div className="space-y-6 border border-indigo-50 p-5 mt-5 rounded-xl">
      <h5 className="text-lg text-theme-gray-2 font-semibold">Operational</h5>
      <Row gutter={[30, 30]}>
        {formattedData
          ?.filter((item) => item?.length)
          ?.map((info, index) => {
            return (
              <Col
                key={index}
                span={8}
                className="space-y-4 border-r border-r-theme-indigo-50 last:border-r-0"
              >
                {info?.map(({ label, value }, index) => (
                  <div key={index} className="space-y-1.5">
                    <p className="text-theme-gray-500 text-sm">{label}</p>
                    <p className="block text-theme-gray-900 !text-base font-medium">
                      {value}
                    </p>
                  </div>
                ))}
              </Col>
            );
          })}
      </Row>
    </div>
  );
};

export default ContactDetails;
